// @ts-nocheck
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import ArrowBackward from "@store/Library/Components/Toolkit/Icons/ArrowBackward";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { css } from "styled-components";

export interface LinkBackPresentationProps extends ExpandStyles<LinkBackStyles> {}

export interface LinkBackProps extends LinkBackPresentationProps {
    pageLink?: PageLinkModel;
    onClick?: () => void;
}

export interface LinkBackStyles {
    link?: LinkPresentationProps;
}

export const linkBackStyles: LinkBackStyles = {
    link: mergeProps<LinkBackStyles["link"]>(linkGetActionLinkProps(ArrowBackward), {
        css: css`
            ${breakpointValues(pxToRemArray([16, null, 20, null, 24]), "margin-bottom")}

            @media print {
                display: none;
            }
        `,
    }),
};

const LinkBack: FC<LinkBackProps> = ({ extendedStyles, overridedStyles, pageLink, onClick }) => {
    const styles = useExpandProps(linkBackStyles, extendedStyles, overridedStyles);

    if (!pageLink?.url && !onClick) {
        return null;
    }

    return (
        <Link {...styles.link} href={!onClick ? pageLink?.url : undefined} onClick={onClick}>
            {pageLink?.title ? translate("Back to {0}", pageLink.title) : translate("Back")}
        </Link>
    );
};

export default LinkBack;
